var PerformanceMetrics = /** @class */function () {
  function PerformanceMetrics() {
    this.entries = [];
    this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING = 10;
    this.essErrorCount = 0;
    this.TRIGGER_TYPE_FOCUS = 'focus';
    this.TRIGGER_TYPE_INPUT = 'input';
    this.errorCodes = [];
    this.proxyRegion = '';
  }
  PerformanceMetrics.isStatusCodeInRange = function (statusCode, begin, end) {
    if (isNaN(statusCode)) {
      return false;
    }
    return begin <= statusCode && statusCode <= end;
  };
  PerformanceMetrics.prototype.logTypeaheadRequest = function (query) {
    var triggerType = query.trim().length === 0 ? this.TRIGGER_TYPE_FOCUS : this.TRIGGER_TYPE_INPUT;
    var request = {
      query: query,
      timestamp: Date.now(),
      triggerType: triggerType
    };
    this.entries.push({
      request: request,
      responseShown: false
    });
  };
  PerformanceMetrics.prototype.logResponse = function (response) {
    var _a;
    this.proxyRegion = ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get('x-proxy-region')) || '';
  };
  PerformanceMetrics.prototype.logTypeaheadResponse = function (response) {
    if (response) {
      var query = response.q;
      var suggestionCount = response.sr ? response.sr.length : 0;
      var entry = this.getRequestMetricEntry(query);
      if (entry) {
        var responseTimestamp = Date.now();
        entry.response = {
          latency: responseTimestamp - entry.request.timestamp,
          query: query,
          suggestionCount: suggestionCount,
          timestamp: responseTimestamp
        };
      }
    }
  };
  PerformanceMetrics.prototype.logSuggestionShown = function (query) {
    var entry = this.getResponseMetricEntry(query);
    if (entry) {
      entry.responseShown = true;
    }
  };
  PerformanceMetrics.prototype.logError = function (statusCode) {
    if (!PerformanceMetrics.isStatusCodeInRange(statusCode, 200, 299)) {
      // eslint-disable-next-line no-plusplus
      this.essErrorCount++;
    }
    this.errorCodes.push(statusCode);
  };
  PerformanceMetrics.prototype.getMetrics = function () {
    var _a;
    if (this.entries.length) {
      var metric = {};
      var entryCount = this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING < this.entries.length ? this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING : this.entries.length;
      for (var i = 0; i < entryCount; i++) {
        var entry = this.entries[i];
        if (entry.response) {
          // @ts-ignore
          metric["latency".concat(i)] = entry.response.latency;
          if (i === 0) {
            metric.query0 = entry.response.query;
          }
        }
      }
      metric.latencyMedian = this.getMedianLatency();
      var worstLatencyMetric = this.getWorstLatencyMetric();
      metric.queryWorst = worstLatencyMetric ? worstLatencyMetric.response && worstLatencyMetric.response.query : undefined;
      metric.latencyWorst = worstLatencyMetric ? worstLatencyMetric.response && worstLatencyMetric.response.latency : undefined;
      var last = this.entries[this.entries.length - 1];
      metric.queryLast = last.request.query;
      metric.latencyLast = last.response ? last.response.latency : undefined;
      metric.totalTriggers = this.entries.length;
      metric.totalSuccess = this.getSuccessMetrics().length;
      metric.totalOnePlusCharTypeaheadShown = this.entries.filter(function (entry) {
        return entry.request.query && entry.responseShown;
      }).length;
      metric.onFocusTypeaheadShown = ((_a = this.getResponseMetricEntry('')) === null || _a === void 0 ? void 0 : _a.responseShown) || false;
      if (this.essErrorCount > 0) {
        metric.essErrorCount = this.essErrorCount;
      }
      if (this.errorCodes.length > 0) {
        metric.error = this.errorCodes.join(',');
      }
      metric.proxyRegion = this.proxyRegion;
      return metric;
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getRequestMetricEntry = function (query) {
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.request.query === query && !entry.response) {
        return entry;
      }
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getResponseMetricEntry = function (query) {
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.request.query === query && entry.response) {
        return entry;
      }
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getWorstLatencyMetric = function () {
    var worstLatencyMetric;
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.response) {
        if (!worstLatencyMetric || worstLatencyMetric.response && worstLatencyMetric.response.latency < entry.response.latency) {
          worstLatencyMetric = entry;
        }
      }
    }
    return worstLatencyMetric;
  };
  PerformanceMetrics.prototype.latencySortFunction = function (a, b) {
    if (a.response && b.response) {
      return a.response.latency - b.response.latency;
    }
    if (a.response) {
      return -1;
    }
    return b.response ? 1 : 0;
  };
  PerformanceMetrics.prototype.getMedianLatency = function () {
    var medianLatency;
    var successMetrics = this.getSuccessMetrics();
    successMetrics.sort(this.latencySortFunction);
    if (successMetrics.length) {
      var mid = Math.floor(successMetrics.length / 2);
      // @ts-ignore
      var midLatency = successMetrics[mid].response.latency;
      if (successMetrics.length % 2) {
        medianLatency = midLatency;
      } else {
        // @ts-ignore
        var midMinusOneLatency = successMetrics[mid - 1].response.latency;
        medianLatency = (midMinusOneLatency + midLatency) / 2;
      }
    }
    return medianLatency;
  };
  PerformanceMetrics.prototype.getSuccessMetrics = function () {
    return this.entries.filter(function (entry) {
      return entry.response;
    });
  };
  return PerformanceMetrics;
}();
export { PerformanceMetrics };